import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
const CHECKOUT_URL = 'https://mega-pack-industrializacion-de-alimentos-en-el-aula.impultienda.ar/checkout';
const includes = ['Tomo 1 — Las Bases del Taller Profesional', 'Tomo 2 — De la Materia Prima a la Conservación', 'Tomo 3 — Tecnología de Lácteos y Cárnicos', 'Tomo 4 — Del Envase al Consumidor', 'Tomo 5 — Del Taller al Emprendimiento', 'Bono 1 — Guía Maestra de Inocuidad y Seguridad Alimentaria', 'Bono 2 — Manual Completo de Métodos de Conservación', 'Bono 3 — Enciclopedia de Materias Primas y Calidad', 'Bono 4 — Procesos Alimentarios Explicados Paso a Paso', 'Bono 5 — Diccionario Profesional de Tecnología de los Alimentos', 'Banco de paquete de actividades adicionales', 'Banco de Evaluaciones', 'Acceso inmediato y pago único', 'Garantía de 7 días'];
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-warmwhite" data-id="element-278" data-mp="7vwcwafrj367">
      <div className="max-w-2xl mx-auto" data-id="element-279" data-mp="1mhpz060ob8eq">
        <div className="text-center mb-12" data-id="element-280" data-mp="1mihnyxzrm7w1">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green mb-4" data-id="element-281" data-mp="1hpoksejy37m2">
            Accedé al Mega Pack completo
          </h2>
          <p className="text-slate" data-id="element-282" data-mp="1cosexvg19be0">
            Un único pago. Todo el sistema, los 5 tomos y los 5 bonos.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-white border-2 border-green rounded-3xl p-8 md:p-10 relative shadow-lg" data-id="element-283" data-mp="25faj6zshtit0">
          <div className="text-center mb-8" data-id="element-284" data-mp="k2pjtrm7zdid">
            <h3 className="text-2xl font-serif font-bold text-ink mb-2" data-id="element-285" data-mp="k3irqvwx0923">
              Mega Pack Industrialización de Alimentos en el Aula
            </h3>
            <p className="text-slate text-sm" data-id="element-286" data-mp="hhi2h8t4aogx">
              Sistema completo para planificar, enseñar y evaluar todo el año
            </p>
          </div>

          <ul className="space-y-3 mb-10" data-id="element-287" data-mp="merxd3z9zsc5">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-ink" data-id="element-288" data-mp="7jc4316is0gt" data-mpi={i}>
                <Check size={16} className="text-green shrink-0 mt-0.5" data-id="element-289" data-mp="chdi37p399lf" />
                <span data-id="element-290" data-mp="3uwecqbxzajqn">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-8" data-id="element-291" data-mp="3hqj0sju0fvj">
            <p className="text-slate text-sm mb-1" data-id="element-292" data-mp="3jjqga29r44l">Un único pago de:</p>
            <p className="text-5xl font-bold text-green" data-id="element-293" data-mp="3kz9ps9wb6k8s">USD 19,90</p>
          </div>

          <Button href={CHECKOUT_URL} variant="green" className="w-full" onLinkClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              content_name: 'Mega Pack Industrialización de Alimentos en el Aula',
              value: 19.9,
              currency: 'USD'
            });
          }
        }} data-id="element-294" data-mp="3px1r1uiufipn">
            QUIERO EL MEGA PACK
          </Button>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mt-6 text-xs text-slate font-medium" data-id="element-295" data-mp="369f2qx92td8s">
            <span data-id="element-296" data-mp="3g9z6q7nzcvup">🔒 Pago seguro</span>
            <span data-id="element-297" data-mp="3g8xljad92sz9">⚡ Acceso inmediato</span>
            <span data-id="element-298" data-mp="3g7mft508vb5i">🛡️ Garantía 7 días</span>
          </div>
        </motion.div>

        <p className="text-center text-sm text-slate mt-8" data-id="element-299" data-mp="3bam8yrvkm4dc">
          Pagás en tu moneda local. El importe se adapta automáticamente al país
          desde donde comprás.
        </p>
      </div>
    </section>;
}